export const axiosBaseUrl = 'https://blog.t-tool.cn/fs-server/';
export const author = '伍努力';
export const spaceId = '7457905733464588289';
export const  spaceName = 'jijiane-cn';
export const aId = 'cli_a70a368693bf900e';
export const aSecret = '6nhPzOQKAm2NWAQerQ6owdltn6VyQkoz';
export const showReadCount = true;//是否显示阅读量
export const showContent = false;//是否显示文本描述
//85
/*export const  spaceName = 'wuyiping';
export const spaceId = '7459569821472374803';//知识库空间id
export const aId = 'cli_a70f0b652a18d00d';//appid
export const aSecret = '1Q34gXZAfNpuodbwHiG3yb6U87Fm8FKj';//appid*/


